// EditProfile.jsx
import React, { useState } from 'react';
import { usePage } from '@inertiajs/react';
import UserProfileForm from './UserProfileForm';
import SelectedScriptsList from './SelectedScriptsList';
import ScriptSelectionModal from './ScriptSelectionModal';
import ProfileHelpSection from './ProfileHelpSection';
import { toast } from 'react-toastify';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import ProfileQuestionsSection from './ProfileQuestionsSection';

const EditProfile = () => {
  const { urls, flash, profile } = usePage().props;
const [isPublic, setIsPublic] = useState(profile.is_public);
const [nickname, setNickname] = useState(profile.nickname);
  const [isModalOpen, setIsModalOpen] = useState(false);
  
  return (
    <div className="container py-4">
      {flash.success && (
        <div className="alert alert-success mb-4" role="alert">
          {flash.success}
        </div>
      )}
      
      {/* Page Header */}
<header className="d-flex justify-content-between align-items-center mb-4">
  <div>
    <h1 className="display-5 fw-bold">Edit Your Profile</h1>
    <p className="text-muted">
      Customize how you appear to other writers and industry professionals
    </p>
  </div>
{isPublic && nickname && (
  <div>
<a
  href={`/portfolios/${profile.nickname}`}
  className="btn btn-outline-primary"
  target="_blank"
  rel="noopener noreferrer"
>
      View Public Profile
    </a>
  </div>
  )}
</header>

      
      {/* Main Content */}
      <div className="row g-4">
        <div className="col-12">
          <UserProfileForm
  onPublicChange={setIsPublic}
  onNicknameChange={setNickname}
/>

        </div>
        
        <div className="col-12">
          <SelectedScriptsList onOpenModal={() => setIsModalOpen(true)} />
        </div>
        
     {/* Lightning-round Q & A */}
        <div className="col-12">
          <ProfileQuestionsSection />
        </div>

        <div className="col-12">
          <ProfileHelpSection />
        </div>
      </div>
      
      {/* Script Selection Modal */}
      <ScriptSelectionModal 
        isOpen={isModalOpen} 
        onClose={() => setIsModalOpen(false)} 
      />
      <ToastContainer position="top-right" autoClose={3000} />
    </div>
  );
};

export default EditProfile;